export enum TabValues {
  DIRECT_LINK = 'directLink',
  EMBED_PAGE = 'embedPage',
  ADD_BUTTON = 'addButton',
  QR_CODE = 'qrCode'
}
